import * as React from 'react';
import {Link, useParams} from "react-router-dom";

import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// Загружаем только latin+cyrillic (используются в интерфейсе), а не все 7 языковых сабсетов каждого веса
import '@fontsource/roboto/latin-300.css';
import '@fontsource/roboto/cyrillic-300.css';
import '@fontsource/roboto/latin-400.css';
import '@fontsource/roboto/cyrillic-400.css';
import '@fontsource/roboto/latin-500.css';
import '@fontsource/roboto/cyrillic-500.css';
import '@fontsource/roboto/latin-700.css';
import '@fontsource/roboto/cyrillic-700.css';

import s from "../../../../../Themes/reactComponents.module.scss"

export function NavigationTabs() {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const firstSegment = pathSegments[0] || 'today';
    
    // Don't set value to 'progress' since it's not a tab - it's accessed from navbar
    const validTabs = ['today', 'inbox', 'calendar', 'properties', 'booking-request'];
    const currentValue = validTabs.includes(firstSegment) ? firstSegment : false;
    
    const [value, setValue] = React.useState(currentValue);

    //refactor

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', bgColor: 'background.paper' }}>
            <Tabs value={value} onChange={handleChange} centered>
                <Tab label="Сегодня" value="today" component={Link} className={s.Link} to={"today"}/>
                <Tab label="Входящие" value="inbox" component={Link} className={s.Link} to={"inbox"}/>
                <Tab label="Календарь" value="calendar" component={Link} className={s.Link} to={"calendar"}/>
                <Tab label="Объявления" value="properties" component={Link} className={s.Link} to={"properties"}/>
                <Tab label="Бронирования" value="booking-request" component={Link} className={s.Link} to={"booking-request/upcoming"}/>
            </Tabs>
        </Box>
    );
}